import React, { useEffect, useState, Component } from 'react';
import { SalesPage } from './pages/SalesPage';
function NotFound() {
  return <div className="flex flex-col items-center justify-center min-h-screen bg-rose-50 text-slate-900 px-4 text-center" data-id="element-0">
      <h1 className="text-6xl font-extrabold text-rose-600 mb-4" data-id="element-1">404</h1>
      <p className="text-xl text-slate-600 mb-8" data-id="element-2">Página no encontrada</p>
      <a href="/disciplina-anti-flojera" className="px-6 py-3 bg-rose-600 text-white font-bold rounded-full hover:bg-rose-700 transition-colors" data-id="element-3">
        Ir a Disciplina Anti-Flojera
      </a>
    </div>;
}
export function App() {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const handlePop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, []);
  const normalized = decodeURIComponent(path).replace(/\/$/, '');
  if (normalized === '/disciplina-anti-flojera' || normalized === '/Disciplina Anti-Flojera' || normalized === '' || normalized === '/') {
    return <SalesPage data-id="element-4" />;
  }
  return <NotFound data-id="element-5" />;
}